

import React, { useEffect, useState } from "react";
import { FaEdit, FaPlus } from "react-icons/fa";
import FileUploader from "../../components/fileManager/FileUploader";
// import "bootstrap/dist/css/bootstrap.min.css";
import { useLoading } from "../../components/LoadingProvider";

import {
  getAllPlantGroups,
  createPlantGroup,
  updatePlantGroup,
} from "../../services/plants/adminPlantsService";

import { useTranslation } from 'react-i18next';

import LanguageDropdown from "../../components/LanguageDropdown";
import LanguageFlag from "../../components/LanguageFlag";


const PlantGroupAdmin = () => {
  const [groups, setGroups] = useState([]);
  const [formData, setFormData] = useState({
    name: "",
    description: "",
    isActive: true,
    image: "",
  });
  const [editId, setEditId] = useState(null);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const { toast } = useLoading()
  
  const [isEditMode, setIsEditMode] = useState(false);




  useEffect(() => {
    fetchGroups();
  }, []);

    const BASE_URL = process.env.REACT_APP_BASE_URL;

    const { t, i18n } = useTranslation();


  const fetchGroups = async () => {
    try {
      const res = await getAllPlantGroups();
      setGroups(res); // depends on HTTP wrapper
    } catch (err) {
      console.error(err);

      const txt = t('console.planetgroup.messages.fetch_group_catch_error');


      setError(txt);
      toast.error(txt);

    }
  };

  // Optional reset function
const resetForm = () => {
  setFormData({
    name: "",
    description: "",
    isActive: true,
    image: "",
    language: ""
  });
  setIsEditMode(false);
  setEditId(null)
};

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({ ...formData, [name]: type === "checkbox" ? checked : value });
  };

  const validateForm = () => {
    if (!formData.name.trim() || !formData.description.trim()) {

      const txt = t('console.planetgroup.messages.validation_form_required_fields');

      setError(txt);
      toast.error(txt);

      return false;
    }
    // if (formData.image && !formData.image.startsWith("http")) {
    //   setError("Image must be a valid URL.");
    //   return false;
    // }

     if (!formData.image) {

      const txt = t('console.planetgroup.messages.validation_form_mandatory_image');


      setError(txt);
       toast.error(txt);
      return false;
    }

    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    try {
      const payload = {
        name: formData.name,
        description: formData.description,
        isActive: formData.isActive,
        image: formData.image,
        language:formData.language
      };

      if (editId) {
        await updatePlantGroup(editId, payload);
        const txt = t('console.planetgroup.messages.handleSubmit_success_update');
        setSuccess(txt);
        toast.success(txt);
      } else {
        await createPlantGroup(payload.name, payload.description, payload.image);
        const txt = t('console.planetgroup.messages.handleSubmit_success_create');
        setSuccess(txt);
        toast.success(txt);
      }

      setFormData({ name: "", description: "", isActive: true, image: null });
      setEditId(null);
      setError("");
      fetchGroups();
    } catch (err) {
      console.error(err);
      const txt = t('console.planetgroup.messages.handleSubmit_catch_msg');

      setError(txt);
      toast.error(txt);
    }
  };

  const handleEdit = (group) => {
    console.log(group)
    setEditId(group._id);
    setFormData({
      name: group.name,
      description: group.description,
      isActive: group.isActive,
      language: group.language,
      image: group.image || "",
    });
    setError("");
    setSuccess("");
    setIsEditMode(true);

  };

  return (
    <div className="container py-5">
      <h2 className="mb-4 text-center fw-bold">{ t('console.planetgroup.adminform.title') }  </h2>

      {error && <div className="alert alert-danger">{error}</div>}
      {success && <div className="alert alert-success">{success}</div>}

      {/* Form */}
      <div className="card mb-5 shadow-sm">
        <div className="card-header">
          {editId ?  t('console.planetgroup.adminform.cardـheaderـedit')   :
                       t('console.planetgroup.adminform.cardـheaderـadd')  }
        </div>
        <div className="card-body">
          <form onSubmit={handleSubmit} className="row g-3">

            <div className="col-md-3">

                <LanguageDropdown
                    defaultValue={formData.language}
                    onChange={(value) =>
                        setFormData((prev) => ({ ...prev, language: value }))
                    }
/>

            </div>

            <div className="col-md-3">
              <label className="form-label">  {t('console.planetgroup.adminform.form_group_name') }  </label>
              <input
                type="text"
                name="name"
                className="form-control"
                value={formData.name}
                onChange={handleChange}
                required
              />
            </div>

      

            <div className="col-md-6">
                <label className="form-label"> {t('console.planetgroup.adminform.form_upload_image_label') }   </label>
                <FileUploader defaultImageUrl={formData.image}
                    onUpload={(url) => setFormData((prev) => ({ ...prev, image: url }))}
                />
                </div>


            <div className="col-12">
              <label className="form-label">  {t('console.planetgroup.adminform.form_upload_image_description') }    </label>
              <textarea
                name="description"
                className="form-control"
                rows={3}
                value={formData.description}
                onChange={handleChange}
                required
              />
            </div>

            <div className="col-md-6 d-flex align-items-center">
              <div className="form-check form-switch mt-3 d-none">
                <input
                  className="form-check-input"
                  type="checkbox"
                  name="isActive"
                  checked={formData.isActive}
                  onChange={handleChange}
                />
                <label className="form-check-label"> {t('console.planetgroup.adminform.form_upload_is_active') }   </label>
              </div>
            </div>

            <div className="col-md-6 text-end mt-3">
              <button type="submit" className="btn btn-primary">
                <FaPlus className="me-2" />
                {editId ?   t('console.planetgroup.adminform.form_submit_button_update_label')   :  t('console.planetgroup.adminform.form_submit_button_create_label') }
              </button>

              {isEditMode && (
                    <button
                        type="button"
                        className="btn btn-secondary  "
                        onClick={resetForm}
                    >
                        {t('console.planetgroup.adminform.form_submit_button_cancel_edit_label') }
                    </button>
                    )}



            </div>

            
          </form>
        </div>
      </div>

      {/* Group List */}
      <h4 className="mb-3">   {t('console.planetgroup.adminform.form_table_title') }    </h4>
      <div className="table-responsive shadow-sm">
        <table className="table table-striped table-bordered">
          <thead className="table-light">
            <tr>
              <th>  {t('console.planetgroup.adminform.form_table_columns.name') }  </th>
              <th>  {t('console.planetgroup.adminform.form_table_columns.language') }   </th>
              <th>  {t('console.planetgroup.adminform.form_table_columns.image') }   </th>
              <th>  {t('console.planetgroup.adminform.form_table_columns.description') }   </th>
              <th>  {t('console.planetgroup.adminform.form_table_columns.active') }   </th>
              <th>   {t('console.planetgroup.adminform.form_table_columns.createdAt') }   </th>
              <th>    {t('console.planetgroup.adminform.form_table_columns.action') }   </th>
            </tr>
          </thead>
          <tbody>
            {groups.map((group) => (
              <tr key={group._id}>
                <td>{group.name}</td>
                <td> <span style={{fontSize:'24px'}}>  { <LanguageFlag language={group.language}/>  } </span> </td>
                <td>{group.image ? <img src={BASE_URL+group.image} alt='preview' width={64}/>: '-'}</td>
                <td>{group.description}</td>
                <td>
                  <span
                    className={`badge bg-${group.isActive ? "success" : "secondary"}`}
                  >
                    {group.isActive ? "Active" : "Inactive"}
                  </span>
                </td>
                <td>{new Date(group.createdAt).toLocaleDateString()}</td>
                <td>
                  <button
                    className="btn btn-sm btn-outline-primary"
                    onClick={() => handleEdit(group)}
                  >
                    <FaEdit className="me-1" /> {" "}
                    
                     {t('console.planetgroup.adminform.edit_btn_label') }  

                  </button>
                </td>
              </tr>
            ))}
            {groups.length === 0 && (
              <tr>
                <td colSpan="5" className="text-center text-muted">
                  

                     {t('console.planetgroup.adminform.table_no_data') }  

                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default PlantGroupAdmin;
